import Accordian from './Accordian/Accordian1';

export default function Care (){
    return <>
        <Accordian/>
    </>
}